{
  "services": [
    {
      "id": "boitiers",
      "num": "01",
      "title": "Boîtiers",
      "lede": "Reflex 35mm, TLR moyen format, télémétriques, compacts mécaniques — je remets en état tout ce qui a une bobine à l'intérieur.",
      "body": [
        "Un boîtier argentique, c'est entre 200 et 400 pièces mécaniques qui travaillent ensemble. Après 40 ans de service, les huiles sèchent, les mousses se décomposent, la cellule dérive. La plupart de ces pannes ne nécessitent ni pièces rares, ni miracle — juste du temps, de bons outils et beaucoup d'expérience.",
        "Je travaille principalement sur les modèles Canon, Nikon, Pentax, Minolta, Olympus et Yashica pour le 35mm ; Rolleiflex, Mamiya et Hasselblad pour le moyen format."
      ],
      "image": "rollei",
      "imageLabel": "Rolleiflex en vue éclatée",
      "bullets": [
        "Révision CLA complète",
        "Remplacement des mousses",
        "Réparation obturateur",
        "Calibration cellule"
      ]
    },
    {
      "id": "objectifs",
      "num": "02",
      "title": "Objectifs",
      "lede": "Champignons sur les lentilles, lamelles de diaphragme collées, bague de mise au point molle. Un optique se démonte, se nettoie, se remonte aligné.",
      "body": [
        "Le plus délicat avec les objectifs anciens, c'est l'alignement au remontage. Une lentille remise à un centième de millimètre près, c'est une image nette ; mal alignée, c'est un flou permanent. Je dispose d'un banc de collimation pour vérifier l'axe optique avant de rendre la pièce.",
        "Mention spéciale pour les champignons : ce n'est pas une sentence, mais il faut intervenir rapidement avant qu'ils ne gravent définitivement le traitement des lentilles."
      ],
      "image": "objectif",
      "imageLabel": "Objectif démonté en vue éclatée",
      "bullets": [
        "Nettoyage intérieur",
        "Traitement des champignons",
        "Diaphragme & lamelles",
        "Dégraissage hélicoïde"
      ]
    },
    {
      "id": "accessoires",
      "num": "03",
      "title": "Accessoires",
      "lede": "Cellules à main, obturateurs centraux, dos interchangeables, posemètres — tout le petit écosystème autour du boîtier.",
      "body": [
        "Les cellules Weston au sélénium, les Gossen et Sekonic au CdS se recalibrent et se remettent aux normes. Pour les obturateurs centraux — Compur, Prontor, Copal équipant les chambres, les TLR et le moyen format — je procède au démontage complet, au dégraissage des lamelles et au nouveau réglage des vitesses au banc.",
        "Dos Hasselblad et Mamiya : étanchéité, compteur, verrouillage. Petite pièce, grosses conséquences si elle lâche en plein shooting."
      ],
      "image": "compur2",
      "imageLabel": "FIG. 03 — OBTURATEUR CENTRAL, VUE ÉCLATÉE",
      "bullets": [
        "Révision cellule",
        "Obturateur central",
        "Dos interchangeable",
        "Posemètres"
      ]
    },
    {
      "id": "personnalisation",
      "num": "04",
      "title": "Personnalisation",
      "lede": "Un second atelier qui ne fait que du sur-mesure — cuirettes, couleurs, gravures. Votre boîtier reste identique en mécanique, unique à l'œil.",
      "body": [
        "Remplacement de la cuirette d'origine par du cuir véritable, du synthétique haute qualité ou des textures originales (peau de serpent, galuchat reconstitué, feutre teinté). Plus de quarante teintes en stock, découpe au gabarit exact du modèle — Leica M, Canon AE-1, Pentax K1000 et bien d'autres.",
        "Changement de couleur du capot par peinture poudre ou laque haute tenue, gravure laser sur la base métallique, finition satinée, mate ou brossée. Le boîtier reste parfaitement fonctionnel, la mécanique intacte."
      ],
      "image": "personnalisation",
      "imageLabel": "Rolleiflex personnalisé",
      "bullets": [
        "Cuirette sur mesure",
        "Changement de couleur",
        "Gravure personnalisée",
        "Finitions spéciales"
      ]
    }
  ],
  "translations": {
    "boitiers": {
      "title": "Camera bodies",
      "lede": "35mm SLRs, medium-format TLRs, rangefinders and mechanical compacts. If it has a film spool inside, I can usually bring it back to life.",
      "body": [
        "A film camera body contains hundreds of mechanical parts working together. After decades of use, oils dry, foams crumble and meters drift.",
        "I mainly work on Canon, Nikon, Pentax, Minolta and Yashica 35mm cameras, plus Rolleiflex, Mamiya and Hasselblad medium-format systems."
      ],
      "imageLabel": "Exploded Rolleiflex view",
      "bullets": [
        "Full CLA service",
        "Light-seal replacement",
        "Shutter repair",
        "Meter calibration"
      ]
    },
    "objectifs": {
      "title": "Lenses",
      "lede": "Fungus on glass, oily aperture blades, loose or stiff focus rings. A lens can be opened, cleaned and reassembled in alignment.",
      "body": [
        "The delicate part with older lenses is alignment during reassembly. A tiny shift can turn a good lens into a permanently soft one.",
        "Fungus is not always a death sentence, but it should be treated before it permanently damages the coating."
      ],
      "imageLabel": "Exploded lens view",
      "bullets": [
        "Internal cleaning",
        "Fungus treatment",
        "Aperture blades",
        "Helicoid service"
      ]
    },
    "accessoires": {
      "title": "Accessories",
      "lede": "Handheld meters, leaf shutters, interchangeable backs and accessories: the small ecosystem around the camera body.",
      "body": [
        "Weston, Gossen or Sekonic meters can be recalibrated. Compur, Prontor and Copal leaf shutters can be stripped, cleaned and adjusted on the tester.",
        "Hasselblad and Mamiya backs need reliable seals, counters and locks. Small parts can have big consequences during a shoot."
      ],
      "imageLabel": "Fig. 03 - leaf shutter, exploded view",
      "bullets": [
        "Meter service",
        "Leaf shutter",
        "Interchangeable backs",
        "Light meters"
      ]
    },
    "personnalisation": {
      "title": "Customization",
      "lede": "A second workshop for custom finishes: leatherette, colors and engraving. Mechanically unchanged, visually unique.",
      "body": [
        "Original leatherette can be replaced with genuine leather, high-quality synthetic material or unusual textures cut to the exact camera template.",
        "Top covers can be refinished, engraved or given satin, matte or brushed finishes while keeping the mechanism untouched."
      ],
      "imageLabel": "Customized Rolleiflex",
      "bullets": [
        "Custom leatherette",
        "Color change",
        "Custom engraving",
        "Special finishes"
      ]
    }
  },
  "faq": {
    "fr": [
      [
        "Le devis est-il vraiment gratuit ?",
        "Oui. Vous payez seulement si vous validez la réparation."
      ],
      [
        "Combien de temps pour une réparation ?",
        "La réparation est faite dans la foulée de l'acceptation du devis. Le délai d'attente est entre la réception de votre colis et la réalisation du devis."
      ],
      [
        "Et si c'est irréparable ?",
        "Ça arrive, rarement. Dans ce cas je vous le dis clairement, sans facturer le diagnostic."
      ],
      [
        "Comment envoyer le matériel ?",
        "Après validation de votre demande de prise en charge, vous recevez par email ou sur votre compte client, les instructions nécessaires pour m'envoyer votre matériel."
      ],
      [
        "Y a-t-il une garantie ?",
        "1 an sur la prestation et les pièces remplacées."
      ],
      [
        "Vous déplacez-vous ?",
        "Sur Marseille et Aix-en-Provence, oui, pour des collections importantes."
      ]
    ],
    "en": [
      [
        "Is the quote really free?",
        "Yes. You only pay if you approve the repair."
      ],
      [
        "How long does a repair take?",
        "The repair is carried out right after quote approval. The waiting time is between parcel reception and the quote being prepared."
      ],
      [
        "What if it cannot be repaired?",
        "It happens. In that case I will tell you clearly, without charging for the diagnosis."
      ],
      [
        "How do I ship the equipment?",
        "After your intake request is accepted, you receive the shipping instructions by email or in your customer account."
      ],
      [
        "Is there a warranty?",
        "One year on the work performed and replaced parts."
      ],
      [
        "Do you travel?",
        "Around Marseille and Aix-en-Provence, yes, for larger collections."
      ]
    ]
  },
  "brands": [
    "Canon",
    "Nikon",
    "Pentax",
    "Minolta",
    "Leica",
    "Yashica",
    "Mamiya",
    "Hasselblad",
    "Rollei",
    "Zeiss Ikon",
    "Voigtländer",
    "Contax",
    "Fuji",
    "Konica",
    "Asahi"
  ]
}
